<template>
    <v-simple-table fixed-header>
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">
                        Name
                    </th>
                    <th class="text-left">
                        Unit Cost
                    </th>
                    <th class="text-left">
                        Quantity
                    </th>
                    <th class="text-left">
                        Total
                    </th>
                    <th class="text-left">
                        
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td>{{ item.product.name }}</td>
                    <td>{{ item.cost | currency(currency) }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.cost * item.quantity | currency(currency)  }}</td>
                    <td style="white-space: nowrap;">
                        <v-btn icon @click="$emit('edit', item)">
                            <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="$emit('delete', item)">
                            <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="2">Total</th>
                    <th>{{ totalQuantity }}</th>
                    <th>{{ totalAmount | currency(currency) }}</th>
                    <th>&nbsp;</th>
                </tr>
            </tfoot>
        </template>
    </v-simple-table>
</template>

<script>
export default {
    props: {
        currency: {
            type: String,
            default: () => 'CHF'
        },
        items: {
            type: Array,
            required:true
        }
    },
    computed: {
        totalQuantity() {
            return this.items.reduce((total, line) => {
                return total + parseInt(line.quantity);
            }, 0);
        },
        totalAmount() {
            return this.items.reduce((total, line) => {
                return total + line.quantity * line.cost;
            }, 0);
        },
    }
}
</script>